import { config } from 'config';
import axios from 'axios';
import { flyweight } from 'commons/util/interfaces.js';
import { REST } from 'commons/rest/rest.js';

function RestApiCdn() {
    REST.call(this, axios, config.console_url, { withCredentials: false });

    this.api.interceptors.response.use((response) => response.data);
}

RestApiCdn.prototype = Object.create(REST.prototype);
export const restApiCdn = flyweight(RestApiCdn);

const VERSION = '/console_version.txt';
const getApi = () => restApiCdn.register();

export const getConsoleVersion = () => getApi().get(VERSION);
